import { useState, useEffect, useContext, useRef } from "react";
import {
  FaPhone,
  FaPhoneSlash,
  FaChevronUp,
  FaChevronDown,
} from "react-icons/fa";
import CounterButton from "./CounterButton";
import useSound from "use-sound";
import victorySong from "../assets/sounds/victorySong.mp3";
import { SongsContext } from "../context/SongsContext";
import nagell from "./../assets/images/nagell.png";

function Team1Mobile({
  i,
  setShowCountdown,
  showCountdown,
  showWinner,
  setShowWinner,
  maxScore,
  setWinner,
  localStorageTeamName,
  initTeamName,
  score,
  updateScore,
}) {
  const [state, dispatch] = useContext(SongsContext);
  const [play, { stop }] = useSound(victorySong);
  //const [score, setScore] = useState(0);
  const [usedPhone, setUsedPhone] = useState(false);
  const [teamName, setTeamName] = useState(initTeamName);
  const teamNameRef1 = useRef(teamName);
  //const [songIsPlaying, setUsedPhone] = useState(false);

  // const updateScore = (newScore) => {
  //   dispatch({
  //     type: "update_team" + i.toString() + "_score",
  //     newScore: newScore,
  //   });
  //   localStorage.setItem("team" + i.toString() + "score", newScore);
  // };

  useEffect(() => {
    if (initTeamName) {
      teamNameRef1.current.textContent = initTeamName;
    } else {
      teamNameRef1.current.textContent = "Lag 1";
    }
  }, [initTeamName]);

  // useEffect(() => {
  //   localStorage.setItem("team" + i.toString() + "name", teamName);
  // }, [teamName, i]);
  useEffect(() => {
    console.log("score", score);
  }, [score]);

  return (
    <div
      style={{
        width: "48%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        paddingTop: "1vw",
        paddingRight: "1vw",
        //paddingBottom: "1%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "40vw",
          alignItems: "flex-start",
          justifyContent: "center",
          marginTop: 10,
        }}
      >
        <div
          ref={teamNameRef1}
          style={{
            width: "100%",
            //maxHeight: "8vh",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 1,
            textOverflow: "ellipsis",
            overflow: "hidden",
            fontSize: "clamp(2vh,2vh, 4vh)",
            marginBottom: 20,
            userSelect: "none",
            textAlign: "left",
            maxLength: "15",
          }}
          contentEditable="true"
          type="text"
          spellCheck="false"
          onInput={(e) => {
            let newValue = e.currentTarget.textContent.slice(0, 14);
            setTeamName(newValue);
          }}
        />
        <div
          style={{
            cursor: "pointer",
            //height: "20%",
            //maxHeight: "20%",
            fontSize: 12,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => {
            setUsedPhone(!usedPhone);
            setShowCountdown(!showCountdown);
          }}
        >
          {!usedPhone ? (
            <FaPhone size="24" color="white" />
          ) : (
            <FaPhoneSlash size="24" color="red" />
          )}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          //marginRight: "1vw",
          //marginLeft: "1vw",
          height: "15vh",
          width: "40vw",
        }}
      >
        <div
          style={{
            fontSize: "10vh",
            height: "15vh",
            width: "20vw",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            userSelect: "none",
          }}
        >
          <div>{score}</div>
        </div>
        <div
          style={{
            height: "15vh",
            width: "20vw",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "none",
          }}
        >
          <div
            //className="plusCounterButton"
            style={{
              cursor: "pointer",
              height: "6vh",
              width: "20vw",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#262f43",
              borderRadius: "10px",
              color: "green",
            }}
            onClick={() => {
              let newScore = Number(score) + 1;
              updateScore(newScore);
              if (maxScore > 0 && newScore === maxScore) {
                // play();
                setShowWinner(true);
                // setWinner(i);
              }
            }}
          >
            <FaChevronUp />
          </div>
          <div
            style={{
              cursor: "pointer",
              height: "6vh",
              width: "20vw",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#262f43",
              borderRadius: "10px",
              color: "red",
            }}
            onClick={() => updateScore(Number(score) - 1)}
          >
            <FaChevronDown />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Team1Mobile;
